import { ImageLanguage } from '@avanta/shared/components/ImageLanguage';
import { languages } from '@avanta/shared/constants/common';
import { t } from '@avanta/shared/i18n';

export function copyToClipboard(text: string): void {
  navigator.clipboard.writeText(text);
}

export function mapToLabelValue<T extends object>(
  array: T[] | undefined,
  valueKey: keyof T,
  labelKey: keyof T,
  prefixLabelKey?: string,
  ns?: string
): { label: string; value: string }[] {
  return (array ?? []).map(item => ({
    label: t(`${prefixLabelKey ? `${prefixLabelKey}.` : ''}${String(item[labelKey])}`, { ns }),
    value: String(item[valueKey]),
  }));
}

export const languageOptions = Object.values(languages).map(language => ({
  value: language.value,
  label: language.label,
  leftSlot: <ImageLanguage language={language.value} />,
}));

export function openInNewTab(url: string, target: string = '_blank'): void {
  window.open(url, target, 'noopener,noreferrer');
}

export const scrollToElementById = (id: string): void => {
  const element = document.getElementById(id);
  if (!element) return;
  element.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
};

export const getFileExtension = (type?: string): string => {
  if (!type || !type.includes('/')) return '';
  const [prefix, suffix] = type.split('/');
  return prefix === 'application' ? suffix : prefix;
};
